import React, { useMemo } from "react";
import {  useSelector } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { COUNTRY_CODE_MAP } from "../../../constants/constant";
import styles from "./IBTasksProgress.module.css";

const ALL_COUNTRIES = Object.keys(COUNTRY_CODE_MAP);

const IBTasksProgress = () => {
  const { ibTasksProgress, loading: adminLoading, error: adminError } = useSelector(
    (state) => state.adminDashboard
  );


  const formatNumber = (num) => {
    if (num === null || num === undefined) return "-";
    return num.toLocaleString();
  };

  const displayData = useMemo(() => {
    if (!ibTasksProgress || ibTasksProgress.length === 0) {
      return ALL_COUNTRIES.map(countryCode => ({
        country: countryCode,
        countryCode: countryCode,
        positionsToCheck: null,
        debitNotesPosted: null,
        pdfXmlGenerated: null,
        pdfSentToEInvoicing: null,
        monthName: "",
        status: null
      }));
    }

    const apiDataMap = new Map(
      ibTasksProgress.map(item => {
        return [item.countryCode, item];
      })
    );

    const result = ALL_COUNTRIES.map(countryCode => {
      const apiData = apiDataMap.get(countryCode);
      const finalData = apiData || {
        country: countryCode,
        countryCode: countryCode,
        positionsToCheck: null,
        debitNotesPosted: null,
        pdfXmlGenerated: null,
        pdfSentToEInvoicing: null,
        monthName: ibTasksProgress[0]?.monthName || "",
        status: null
      };
      return finalData;
    });
    return result;
  }, [ibTasksProgress]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <h3 className={styles.title}>IB Tasks Progress</h3>
          <span className={styles.subtitle}>📅 {displayData.length > 0 ? displayData[0].monthName : ""}</span>
        </div>
      </div>

      {adminLoading && (
        <div className={styles.loadingContainer}>
          <p>Loading IB tasks progress...</p>
        </div>
      )}

      {adminError && (
        <div className={styles.errorContainer}>
          <p>Error: {adminError}</p>
        </div>
      )}

      {!adminLoading && !adminError && (
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Country</th>
                <th>Positions to check</th>
                <th>Debit Notes Posted</th>
                <th>PDF / XML Generated</th>
                <th>PDF sent to E-invoicing</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {displayData.map((task, index) => {
                return (
                  <tr key={task.countryCode || index}>
                    <td className={styles.countryCell}>
                      {COUNTRY_CODE_MAP[task.country] || task.country}
                    </td>
                    <td className={styles.numberCell}>
                      {formatNumber(task.positionsToCheck)}
                    </td>
                    <td className={styles.numberCell}>
                      {formatNumber(task.debitNotesPosted)}
                    </td>
                    <td className={styles.numberCell}>
                      {formatNumber(task.pdfXmlGenerated)}
                    </td>
                    <td className={styles.numberCell}>
                      {formatNumber(task.pdfSentToEInvoicing)}
                    </td>
                    <td className={styles.statusCell}>
                      {task.status === "completed" ? (
                        <CheckCircleIcon className={styles.completedIcon} />
                      ) : task.status === null ? (
                        <span className={styles.pendingText}>-</span>
                      ) : (
                        <span className={styles.inProgressText}>In progress</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default IBTasksProgress;
